import { computed, ref } from 'vue'

import { defineStore } from 'pinia'

// App name constants
export const APP_NAMES = {
  CLIENTPORTAL: 'CLIENTPORTAL',
  GOKOLLAB: 'GOKOLLAB',
  COURSES: 'COURSES',
  MEET: 'MEET',
} as const

// App types
export type AppType = (typeof APP_NAMES)[keyof typeof APP_NAMES]

export const useGlobalStore = defineStore('global', () => {
  // App-related state
  const appType = ref<AppType>(APP_NAMES.CLIENTPORTAL) // Default to clientportal

  // App actions
  function setAppType(type: AppType) {
    appType.value = type
  }

  // App getters
  const isClientportal = computed(() => appType.value === APP_NAMES.CLIENTPORTAL)
  const isGokollab = computed(() => appType.value === APP_NAMES.GOKOLLAB)
  const isMeet = computed(() => appType.value === APP_NAMES.MEET)
  const isCourses = computed(() => appType.value === APP_NAMES.COURSES)

  // Additional global state can be added here
  // const theme = ref('light')
  // const language = ref('en')
  // const isLoading = ref(false)
  // const notifications = ref([])
  // etc...

  return {
    // App State & Actions
    appType,
    setAppType,
    isClientportal,
    isMeet,
    isGokollab,
    isCourses,

    // Future global state can be added here
    // theme,
    // language,
    // isLoading,
    // notifications,
  }
})
